import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'

//axios config 
import "./axios"

//vuex config
import store from "./store"
require("./store/subscriber")

//animation dependencies
import "animate.css"
import './registerServiceWorker'

//capacitor config
import "./capacitor";

Vue.config.productionTip = true

//fetch token from payload and attempt sending request to api yo get user profile
store.dispatch("auth/attempt", localStorage.getItem("token")).then(() => {
  //only render the app after attempt to getting user profile, whether is succeed or not 

  new Vue({
    created() {
      //inject analytics here
    },
    router,
    vuetify,
    store,
    render: h => h(App)
  }).$mount('#app')

})
